import { useTabAwareOrderUpdater } from '../hooks/useTabAwareOrderUpdater';

export const OrderStateSync = () => {
    useTabAwareOrderUpdater();

    return null;
};



// WEBPACK FOOTER //
// ./src/components/OrderStateSync.js